import React, { useRef, useState } from "react";
import { AnimatePresence } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import "./FAQSection.css";
import { motion } from "framer-motion";
import { useScroll, useTransform } from "framer-motion";
  const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;

const stackVariants = {

  

  hidden: {},
  visible: { transition: { delayChildren: 0.2, staggerChildren: 0.1 } },
};
const elementVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { type: "spring", stiffness: 60, damping: 12 },
  },
};

// Animation variants
const accordionVariants = {
  collapsed: {
    height: 0,
    opacity: 0,
    transition: { duration: 0.3, ease: "easeInOut" },
  },
  open: {
    height: "auto",
    opacity: 1,
    transition: { duration: 0.4, ease: "easeInOut" },
  },
};

const faqs = [
  {
    q: "Is Barsana a good location for investment?",
    a: "Yes! Barsana is known for its peaceful surroundings and growing real estate value.A paragraph is a series of sentences that are organized and coherent, and are all related to a single topic. Almost every piece of writing you do that is longer than a few sentences should be organized into paragraphs. This is because paragraphs show a reader where the subdivisions of an essay begin and end, and thus help the reader see the organization of the essay and grasp its main points.",
  },
  {
    q: "What types of properties are available in Barsana?",
    a: "You can find residential plots, villas, and farmhouses.A paragraph is a series of sentences that are organized and coherent, and are all related to a single topic. Almost every piece of writing you do that is longer than a few sentences should be organized into paragraphs. This is because paragraphs show a reader where the subdivisions of an essay begin and end, and thus help the reader see the organization of the essay and grasp its main points.",
  },
  {
    q: "How can I book a property visit?",
    a: "Just contact us through our booking form or call our helpline.A paragraph is a series of sentences that are organized and coherent, and are all related to a single topic. Almost every piece of writing you do that is longer than a few sentences should be organized into paragraphs. This is because paragraphs show a reader where the subdivisions of an essay begin and end, and thus help the reader see the organization of the essay and grasp its main points.",
  },
  {
    q: "What amenities are included in the properties?",
    a: "Basic infrastructure, gated security, green zones, and more.A paragraph is a series of sentences that are organized and coherent, and are all related to a single topic. Almost every piece of writing you do that is longer than a few sentences should be organized into paragraphs. This is because paragraphs show a reader where the subdivisions of an essay begin and end, and thus help the reader see the organization of the essay and grasp its main points.",
  },
  {
    q: "Are there financing options available?",
    a: "Yes, flexible financing and EMI options are available for most properties.A paragraph is a series of sentences that are organized and coherent, and are all related to a single topic. Almost every piece of writing you do that is longer than a few sentences should be organized into paragraphs. This is because paragraphs show a reader where the subdivisions of an essay begin and end, and thus help the reader see the organization of the essay and grasp its main points.",
  },
];

const AccordionItem = ({ title, children, isOpen, onClick }) => (
  <div className="faqsection">
    <div
      onClick={onClick}
      className={`d-flex justify-content-between align-items-center px-4 py-3 accordion-header ${
        isOpen ? "open" : ""
      }`}
    >
      <span className="accordion-title">{title}</span>
      <span className="accordion-toggle">{isOpen ? "–" : "+"}</span>
    </div>
    <AnimatePresence initial={false}>
      {isOpen && (
        <motion.div
          className="px-4 overflow-hidden bg-light rounded-bottom transition-content"
          variants={accordionVariants}
          initial="collapsed"
          animate="open"
          exit="collapsed"
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const toggleIndex = (idx) => setActiveIndex(activeIndex === idx ? null : idx);

  const refStack = useRef(null);

  const { scrollYProgress } = useScroll();
  const yOffset = useTransform(scrollYProgress, [0, 0.5], [100, 0]);

  return (
    <div id="kilaa" className="container " >
      <div className="row align-items-start">
        <div className="col-md-6 pe-md-5 faq-title">
          <div className="faq-header">
          <p id="subtitle1" className="text-center  mb-2">
            Do you have any questions?
          </p>
        
           
          <h2 className="fw-bold text-center mb-2">FAQS</h2>
            </div>
          
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              title={f.q}
              isOpen={activeIndex === i}
              onClick={() => toggleIndex(i)}
            >
              <p className="mb-0">{f.a}</p>
            </AccordionItem>
          ))}
        </div>

        <div className="col-md-5" data-aos="fade-up"
     data-aos-duration="3000">
  <div className=" kinu position-relative px-3" style={{ paddingBottom: '100px' }}>
    <img
      src={`${IMAGE_BASE_URL}/image2.png`}
      alt="Illustration"
      className="img-fluid position-absolute top-0 start-50 translate-middle-x"
    />
  </div>
</div>

      </div>
    </div>
  );
};

export default FAQSection;
